import React, { useState } from "react";
import {ChevronsUpDown, SquarePen} from "lucide-react";
import DeleteModal from "../Modal/DeleteModal";
import { can_visit } from "../../helpers";
import EditUserRoleModal from "../Modal/EditUserRoleModal";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function AllMembersDataTable(props) {
  const {
    tableData = [],
    handleDeleteRecord = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    handleUpdatedUserRole = () => {},
    userRoles = []
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  
  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const handleOpenEditUserRoleModal = (user) => {
    setActiveModal(true);
    setSelectedUser(user);
  };

  const handleCloseEditUserModal = () => {
    setActiveModal(false);
    setSelectedUser({});
  };

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th>
                <div
                  onClick={() => { handleOrderChange("last_name"); }}
                  className={
                    orderBy === "last_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("email"); }}
                  className={
                    orderBy === "email" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Email <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("user_name"); }}
                  className={
                    orderBy === "user_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Username <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>Roles</th>
              {can_visit("settings_users_all_users_delete") && (
                <th></th>
              )}
            </tr>
          </thead>
          <tbody>
          {!dataLoading ? (
            tableData.length > 0 ? (
              tableData?.map((item, index) => (
                <tr key={index}>
                  <td>{item?.last_name} {item?.first_name}</td>
                  <td>{item?.email}</td>
                  <td>{item?.user_name}</td>
                  <td>
                    {item?.roles?.filter(name => userRoles.includes(name)).map((name, index) => (
                      <span key={index} className="docpro_badge docpro_badge_olive">
                        {name}
                      </span>
                    ))}
                    <button className="docpro_icon_btn"
                      onClick={() => handleOpenEditUserRoleModal(item)}
                    >
                      <SquarePen width={18} height={18} />
                      <span className="docpro_tip">Edit User</span>
                    </button> 
                  </td>
                  {can_visit("settings_users_all_users_delete") && (
                    <td>
                      <div
                        className="docpro_icon_btns"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <DeleteModal
                          handleDelete={() => {
                            handleDeleteRecord(item.id);
                          }}
                          tooltip={true}
                          name={`${item?.last_name} ${item?.first_name}`}
                          previousScrollPosition={previousScrollPosition}
                          setPreviousScrollPosition={setPreviousScrollPosition}
                        />
                      </div>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="6">
                  No data available
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="6">
                Loading...
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <EditUserRoleModal
          onClose={handleCloseEditUserModal}
          userData={selectedUser}
          handleUpdatedUserRole={handleUpdatedUserRole}
          userRoles={userRoles}
        />
      )}
    </>
  );
}
